



import { Vue, Component } from 'vue-property-decorator';

// sections
import Hero from '@/components/sections/Hero.vue';
import Projects from '@/components/sections/Projects.vue';
import PersonalWork from "@/components/sections/PersonalWork.vue";
import Instagram from "@/components/sections/Instagram.vue";
import Footer from "@/components/sections/Footer.vue";


@Component({
    components: {
        Hero,
        Projects,
        PersonalWork,
        Instagram,
        Footer
    }
})
export default class Home extends Vue{

}
